import React from 'react'
import { Container, Row, Col } from 'reactstrap';
import { isMobile } from "react-device-detect";

import Property from '@episerver/spa-core/Components/Property';


const GetSize = (props) => {
    
    
    //var H = window.innerHeight;
    var H = window.document.body.offsetHeight;
    
       return H
         
      };


export default GetSize


